import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'bskfilters',
    templateUrl: 'bskfilters.component.html',
    styleUrls: ['bskfilters.component.scss']
})
export class BskFiltersComponent {
    @Input() public dataBskFilters;
    @Input() public idRequest;
    @Input() public height = '75vh';
    @Output() public dataBskFilterSelected = new EventEmitter<any>();

    public onClickFilter(adataBskFilters) {
        if (adataBskFilters.value !== null && adataBskFilters.value !== undefined) {         
            this.dataBskFilterSelected.emit(adataBskFilters.value);
        }
    }
}
